import { useMutation } from 'react-query';

import * as RestApi from 'core/network/RestApi';
import { BulkRetargetingCampaign } from 'models/offsite/Campaign/BulkRetargetingCampaign';
import { generatePath } from 'react-router';
import { BulkRetargetingCampaignEndpoints } from '../constants';

export interface CreateBulkRetargetingCampaignRequest {
  siteId: string;
  version: 'v2';
  type: 'bulkRetargeting';
  state: 'DRAFT';
  name: string;
  // @TODO: remove after v2 feature flag is gone
  segments?: any[];
}

export const createBulkRetargetingCampaign = ({
  siteId,
  segments,
  ...payload
}: CreateBulkRetargetingCampaignRequest) => {
  return RestApi.post<BulkRetargetingCampaign, CreateBulkRetargetingCampaignRequest>(
    generatePath(BulkRetargetingCampaignEndpoints.POST, {
      siteId,
    }),
    {
      ...payload,
      siteId,
      version: 'v2',
      type: 'bulkRetargeting',
      state: 'DRAFT',
    },
  );
};

export const useCreateBulkRetargetingCampaignMutation = () => {
  return useMutation((payload: CreateBulkRetargetingCampaignRequest) => createBulkRetargetingCampaign(payload));
};
